// Copyright © 2021 Move Closer
import { AbstractTypeDriver } from './abstract';
import { RelatedType } from '../contracts';
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class TagDriver extends AbstractTypeDriver {
    constructor() {
        super(...arguments);
        /**
         * Key that stores RelatedType.
         * @protected
         */
        this.typeKey = RelatedType.Tag;
    }
}
